import { styles } from './template.scss';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM } from '../../../../../webcomponents.constants';

export const template = document.createElement('template');

template.innerHTML = `
  <style>${styles}</style>

  <div id='wrapper' class='form-section'>
    <gz-title fontSize='18' fontWeight='500' class='form-subtitle' id='security-subtitle'></gz-title>

    <gz-form-field id='value-form-field' class='label-mw-250 mt-1' required>
      <gz-integrity-monitor-input-with-chips gz-form-input></gz-integrity-monitor-input-with-chips>
      <gz-input-error></gz-input-error>
    </gz-form-field>
  </div>

  <div class='form-section'>
    <${WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM}></${WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM}>
  </div>
`;
